<div class="container">
    <nav class="navbar navbar-dark primary-color pull-right">
          <img src="./assets/images/logo/GOINGPLACES_RGB no tag.jpg" height="80" alt="mdb logo">
      </nav>
    <h2>Thank you for completing the feedback.</h2>
    <div class="btnDiv">
        <button class="btn btn-primary" (click)="viewReport()">View Feedback</button>
    </div>
</div>